import { useQuery } from "@tanstack/react-query";
import trustpilotApi, {
  DEFAULT_TRUSTPILOT_SCORE,
  TRUSTPILOT_API_URL,
  TrustpilotScoreType,
} from "../trustpilotScore";

const useTrustpilotScore = (locale?: string) =>
  useQuery<TrustpilotScoreType, Error>({
    queryKey: [TRUSTPILOT_API_URL, locale],
    queryFn: () => trustpilotApi.fetchTrustpilotScore(locale),
    retry: 1,
    staleTime: Infinity,
    initialData: DEFAULT_TRUSTPILOT_SCORE,
  });
export default useTrustpilotScore;
